import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";

//ng build --base-href "/" --prod
@Injectable({
  providedIn: "root",
})
export class ConfigService {
  public flujoAlterno = false;
  public isLoadingInitialComplete: boolean = false;
  private p_i_marca = 0;
  private bDesarrollo = false;
  private sBaseUrlServicios = "";
  private sBaseUrlSeguridad = "";
  public s3Bucket = "https://inchcape-agendamiento.s3.us-east-2.amazonaws.com/";
  constructor(private cRouter: Router, private cHttpClient: HttpClient) {
    //localStorage.setItem('Token', '11D56EDB-307B-491D-919E-52E9FE091106');
    //localStorage.setItem('MasterUserId', 'A8F20DB0-D6DB-4617-9ADA-D0377CCE32C9');
    //localStorage.setItem("AppId" ,'AF586A48-390C-457B-8FC0-4AEAB7FB400D');
    this.onGenerarUrls();
    //console.log("Init app service");
  }
  private onGenerarUrls() {
    if (!this.bDesarrollo) {
      this.sBaseUrlServicios = "https://api.inchcapelatam.app/adminrest/api/";
      this.sBaseUrlSeguridad =
        "https://api.inchcapelatam.app/seguridadrest/api/";
      // this.sBaseUrlServicios = "https://apiqa.inchcapelatam.app/adminrestqa/api/";
      // this.sBaseUrlSeguridad = "https://apiqa.inchcapelatam.app/seguridadrestqa/api/";
      // this.sBaseUrlServicios = "https://apiqa.inchcapelatam.app/adminrestqa/api/";
      // this.sBaseUrlSeguridad = "https://apiqa.inchcapelatam.app/seguridadrestqa/api/";
      //this.onObtenerMarcaApplicacion();
    } else {
      //this.sBaseUrlSeguridad = "http://localhost:54879/api/"; //EDUARDO
      //this.sBaseUrlServicios = "http://localhost:57229/api/"; //EDUARDO
      //this.sBaseUrlSeguridad = "https://localhost:44303/api/"; //JP
      // this.sBaseUrlServicios = "https://localhost:44314/api/"; //JP
      this.sBaseUrlSeguridad =
        "https://apiqa.inchcapelatam.app/seguridadrestqa/api/";
      this.sBaseUrlServicios =
        "https://apiqa.inchcapelatam.app/adminrestqa/api/";
      //this.sBaseUrlServicios = "http://192.168.1.62/adminrestqa/api/"; //TEO
      //this.sBaseUrlSeguridad = "http://192.168.1.62/seguridadrestqa/api/"; //TEO
      //this.onObtenerMarcaApplicacion();
    }
  }

  public onObtenerMarcaBase(): number {
    return 1;
    let BrandId =
      localStorage.getItem("BrandId") != "null"
        ? parseInt(localStorage.getItem("BrandId"))
        : 0;
    this.p_i_marca = BrandId;
    return this.p_i_marca;
  }

  public onObtenerBaseUrlServicios(sServicio: string): string {
    return this.sBaseUrlServicios + sServicio;
  }

  public onOtenerBaseUrlSeguridad(sServicio: string): string {
    return this.sBaseUrlSeguridad + sServicio;
  }

  public onObtenerParametrosGet(oData) {
    var sParametros = new URLSearchParams(oData);
    return sParametros.toString();
  }
  onObtenerconfiguraciones(oData) {
    let urlRequest =
      this.onObtenerBaseUrlServicios("MasterUserConfigurationGet") +
      "?" +
      this.onObtenerParametrosGet(oData);
    return this.cHttpClient.get<any>(urlRequest);
  }
}
